<template>
  <div>
    <page-main
      :tableData="tableData"
      :loading="loading"
      :tablePage="page"
      @reload="reload"
    >
      <page-header
        ref="header"
        slot="header"
        @query="getData"
        @reset="resetPage"
      />
      <pagination
        size="small"
        align="right"
        slot="pager"
        :current-page="page.curPage"
        :page-size="page.pageSize"
        :page-total="page.pageTotal"
        @change="handlePaginationChange"
      />
    </page-main>
  </div>
</template>

<script>
import PageMain from './main'
import PageHeader from './header'
import BaseTable from '@/mixins/base-table'
export default {
  components: {
    PageHeader,
    PageMain
  },
  mixins: [BaseTable],
  props: {
    code: String,
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      usePage: true,
      taskCode: ''
    }
  },
  watch: {
    code: {
      handler() {
        this.getData()
      },
      immediate: true
    }
  },
  methods: {
    getData(form) {
      this.tableData = []
      if (!this.code) {
        return
      }
      let temp = {
        taskCode: this.code
      }
      form = {
        ...form,
        ...temp
      }
      this.loading = true
      this.$api
        .stockCheckTaskRangeDetailListApi({
          ...form,
          ...this.page
        })
        .then((res) => {
          this.loading = false
          this.setData(res)
        })
        .catch(() => {
          this.loading = false
        })
    }
  }
}
</script>
